<template lang="pug">
  main
    NavBarTransportes
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nueva Salida&nbsp
              |
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12
            FormSalida(:usuarios="usuarios" :cargas="cargas" :vehiculos="vehiculos" @selectUser="selectUser" @saveForm="saveForm" @otroVehiculo="otroVehiculo")
        .columns(v-show="verNotificacionTarjeta")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay Tarjetas asignadas para éste usuario.
        .columns(v-show="verNotificacionVehiculo")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay Vehículos asignados para éste usuario.
        .columns.column-blanco
</template>

<script>
  import NavBarTransportes from './layout/NavBarTransportes.vue'
  import FormSalida from './componentes/FormSalida.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '@/services/usuarios/usuarios'
  import InventarioServices from '@/services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'
  
  export default {
    name: 'NewSalida',
    components: { NavBarTransportes, Loader, FormSalida },
    data() {
      return {
        isLoading: true,
        cargas: [],
        vehiculos: [],
        verNotificacionTarjeta: false,
        verNotificacionVehiculo: false,
        usuarios: [],
        userSelect: {}
      }
    },
    watch: {
      userSelect() {
        this.obtenerVehiculos('u')
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerCargasEfectivale()
      },
      obtenerCargasEfectivale () {
        InventarioServices.getTarjetas_Cargas()
          .then( data => {
            this.cargas = data.map(this.convertirCargas)
            this.obtenerUsuarios()
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirCargas (c) {
        return {
          ...c,
          id: parseInt(c.id),
          abono: Number(c.abono),
          cargo: Number(c.cargo),
          id_comercio: parseInt(c.id_comercio),
          id_respuesta: parseInt(c.id_respuesta),
          id_tarjeta: parseInt(c.id_tarjeta),
          id_ticket: parseInt(c.id_ticket),
          tipo: parseInt(c.tipo),
          transaccion: parseInt(c.transaccion),
        }
      },

      obtenerUsuarios() {
        if (this.userLogin.departamento === 6) {
          usuariosServices.getUsuarios_SeI()
            .then( (res) => {
              let users = res
              this.usuarios = users
              this.isLoading = false
            })
            .catch((e) => {
              this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
              this.isLoading = false
            })
        } else {
          if (this.userLogin.ubicacion === 'EB04') {
            usuariosServices.getUsuarios_Ducto()
              .then( (res) => {
                this.usuarios = res
                this.isLoading = false
              })
              .catch((e) => {
                this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          } else {
            usuariosServices.getUsuarios_Ubicacion(this.userLogin.ubicacion)
              .then( (res) => {
                this.usuarios = res
                this.isLoading = false
              })
              .catch((e) => {
                this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          }
        }
      },
      obtenerVehiculos(isUser) {

        if (isUser === 'u') {
          InventarioServices.getVehiculos_user(this.userSelect.id)
            .then((data) => {
              console.log(data)
              this.vehiculos = data
              if (this.vehiculos.length == 0) {
                this.verNotificacionVehiculo = true
              } else {
                this.verNotificacionVehiculo = false
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          InventarioServices.getVehiculos()
            .then((data) => {
              console.log(data)
              this.vehiculos = data
              if (this.vehiculos.length == 0) {
                this.verNotificacionVehiculo = true
              } else {
                this.verNotificacionVehiculo = false
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
            })
        }
      },
      
      saveForm(f) {
        console.log(f)
        let periodo = moment(f.fechaSalida).format('YYYY-MM')
        InventarioServices.addComb_Salida(f.fechaReg, f.fechaSalida, periodo, this.userSelect.ubicacion, this.userSelect.departamento, f.idV, f.idT, this.userSelect.id, this.userSelect.nombre, f.cargaP, f.cargaL, f.kmActual, f.observacion, f.ticket)
          .then( (data) => {
            this.displayToast(data.success ? 'toasted-primary' : 'bubble' , data.respuesta, data.success ? 'done' : 'ban', 'OK')
            this.isLoading = false
            if (data.success) {
              this.$router.push('/Transportes/Combustible/Salidas')
            }
          })
          .catch( (e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
        
      },
      
      selectUser(user) {
        console.log(user)
        this.userSelect = Object.assign({}, this.userSelect, user)
      },

      otroVehiculo (val) {
        if (val) {
          this.obtenerVehiculos('o')
        } else {
          this.obtenerVehiculos('u')
        }
      },
      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage() {
        this.$router.back()
    }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/NewSalida.vue